import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header with back button */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-primary-dark hover:text-accent-green"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück zur Startseite
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto max-w-4xl px-6 pt-24 pb-20">
        <h1 className="text-4xl font-bold text-primary-dark mb-8">Impressum</h1>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">Anbieterangaben gemäß TMG</h2>
            <p className="mb-4">
              <strong>Diensteanbieter:</strong>
            </p>
            <p className="mb-2">Sofia Laitenberger</p>
            <p className="mb-4">Freiberuflerin</p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Kontaktadresse</h3>
            <p className="mb-2">Richard-Linde-Weg 1</p>
            <p className="mb-4">21033 Hamburg, Deutschland</p>
            <p className="mb-2">
              <strong>Telefon:</strong>{' '}
              <a href="tel:015233527031" className="text-accent-green hover:underline">
                +49 (0) 1523 3527031
              </a>
            </p>
            <p>
              <strong>E-Mail:</strong>{' '}
              <a href="mailto:info@brainhurricane.org" className="text-accent-green hover:underline">
                info@brainhurricane.org
              </a>
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Internetadresse</h3>
            <p>
              <strong>Website:</strong>{' '}
              <a
                href="https://www.brainhurricane.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent-green hover:underline"
              >
                www.brainhurricane.org
              </a>
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Umsatzsteuer</h3>
            <p>
              Sofern umsatzsteuerpflichtig, wird die Umsatzsteuer-Identifikationsnummer auf Anfrage mitgeteilt.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Haftung für Inhalte</h3>
            <p className="mb-4">
              Die Inhalte unserer Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              Gemäß § 7 Abs. 1 TMG sind wir als Diensteanbieter für eigene Inhalte auf unseren
              Webseiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet,
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen bleiben
              unberührt und werden von uns unverzüglich umgesetzt, sobald wir von einer
              Rechtsverletzung Kenntnis erhalten.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Haftung für Links</h3>
            <p className="mb-4">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="mb-4">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
            </p>
            <p>
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links unverzüglich entfernen.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Urheberrecht</h3>
            <p>
              Die durch die Diensteanbieter, deren Mitarbeiter oder in ihrem Auftrag tätigen Personen
              erstellten Inhalte und Werke auf diesen Webseiten unterliegen dem deutschen Urheberrecht.
              Eine Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des Autors oder Urhebers.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold text-primary-dark mb-3">Verbraucherstreitbeilegung</h3>
            <p>
              Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              <strong>Letzte Aktualisierung:</strong> Dezember 2024
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
